import { render, staticRenderFns } from "./myFans.vue?vue&type=template&id=fd2a2d48&scoped=true&"
import script from "./myFans.vue?vue&type=script&lang=js&"
export * from "./myFans.vue?vue&type=script&lang=js&"
import style0 from "./myFans.vue?vue&type=style&index=0&id=fd2a2d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2a2d48",
  null
  
)

export default component.exports